const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");

// MOCKED DATA - US
export const mockedupData = {
  firstName: "Andy",
  lastName: "Dang",
  email: `andy.dang+mockup${timestamp}@unyte.com`,
  organizationName: `andy.dang+mockup${timestamp}@unyte.com`,
  professionalCredentials: "Other",
  address1: "Unyte Headquarters",
  address2: "Unit 001",
  city: "Denver",
  state: "CO",
  country: "US",
  postalCode: "80206",
  accessories: {},
  shippingOption: "",
  agreement: false,
  stripePaymentMethodId: "",
  isMockup: true,
  shippingOptions: [],
  items: [],
  accessoryProducts: [],
  currentStep: 1,
  productCategories: [],
  accessoryCategories: [],
  uuid: "",
  stripeClientSecret: "",
};

// MOCKED DATA - Canada
export const mockedupDataCanada = {
  firstName: "Andy",
  lastName: "Dang",
  email: `andy.dang+mockup${timestamp}@unyte.com`,
  organizationName: `andy.dang+mockup${timestamp}@unyte.com`,
  professionalCredentials: "Other",
  address1: "201 James St N",
  address2: "",
  city: "Hamilton",
  state: "ON",
  country: "CA",
  postalCode: "L8R 2L2",
  accessories: {},
  shippingOption: "",
  agreement: false,
  stripePaymentMethodId: "",
  isMockup: true,
  shippingOptions: [],
  items: [],
  accessoryProducts: [],
  currentStep: 1,
  productCategories: [],
  accessoryCategories: [],
  uuid: "",
  stripeClientSecret: "",
};

// MOCKED DATA - Australia
export const mockedupDataAustralia = {
  firstName: "Andy",
  lastName: "Dang",
  email: `andy.dang+mockup${timestamp}@unyte.com`,
  organizationName: `andy.dang+mockup${timestamp}@unyte.com`,
  professionalCredentials: "Other",
  address1: "218 Rundle St",
  address2: "",
  city: "Adelaide",
  state: "South Australia",
  country: "AU",
  postalCode: "5000",
  accessories: {},
  shippingOption: "",
  agreement: false,
  stripePaymentMethodId: "",
  isMockup: true,
  shippingOptions: [],
  items: [],
  accessoryProducts: [],
  currentStep: 1,
  productCategories: [],
  accessoryCategories: [],
  uuid: "",
  stripeClientSecret: "",
};

// Get mockup data by country ID
export const getMockupData = (countryId?: string) => {
  switch (countryId?.toLowerCase()) {
    case "can":
    case "ca":
      return mockedupDataCanada;
    case "aus":
    case "au":
      return mockedupDataAustralia;
    default:
      return mockedupData;
  }
};
